import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';
import { mobile_xl, mobile_xs } from '../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween, FlexCenter, HideScrollbar, LineClamp } from '../../global/commonStyle';
interface Props {
  isActive?: boolean;
  isRead?: boolean;
  isScrollPage?: boolean;
  isImage?: boolean;
  buttonHeight?: number;
  direction?: 'top' | 'bottom';
  alignment?: 'left' | 'right' | 'center';
  dropdownTopOffset?: number | null; // Use the calculated top offset
  isIconActive?: boolean;
  isTaskDetailPreview?: boolean;
  backgroundUrl?: string;
  isEmpty?: boolean;
}

interface SwipeMsgCardProps {
  isDeleting?: boolean;
  isSwiped?: boolean;
  touchStartX?: number | null;
  touchEndX?: number | null;
  isRearranging?: boolean;
  swipedItemId?: string | null;
  itemId?: string;
  mobile?: boolean;
}

const DropdownWrapper = styled.div`
  padding: var(--space-0) var(--space-8) var(--space-10);
`;

const InboxContainer = styled.div<Props>`
  position: relative;
  ${({ isEmpty }) =>
    isEmpty &&
    css`
      height: 100%;
    `}
`;

const HeaderInbox = styled.div`
  ${AlignCenter}
  gap: var(--space-20);
  max-width: 662px;
  padding: var(--space-14) var(--space-24);
  margin: auto;
  position: relative;
`;
const MainHeader = styled.div<Props>`
  position: sticky;
  top: 0;
  z-index: var(--z-index-999);
  ::after {
    content: '';
    width: 100%;
    height: 70px;
    display: block;
    position: absolute;
    top: 0px;
    z-index: var(--z-index-negative);
    background-image: var(--background-linear-gradient);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center center;
    pointer-events: none;
  }
`;

const InboxMSG = styled.div<Props>`
  display: flex;
  flex-direction: column;
  gap: var(--space-16);
  max-width: 662px;
  padding: var(--space-16) var(--space-24) var(--space-24);
  margin-inline: auto;
  position: relative;
  ${mobile_xl(css`
    max-width: 100%;
    padding: var(--space-0) var(--space-8) var(--space-96);
  `)}
`;

const MSG = styled.div<Props>`
  display: flex;
  justify-content: space-between;
  gap: var(--space-16);
  padding: var(--space-12) var(--space-16) var(--space-12) var(--space-7);
  background-color: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-12);
  align-items: baseline;
  cursor: pointer;
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Standard syntax */
  -webkit-tap-highlight-color: transparent; /* Optional: remove tap highlight on touch */
  .inbox-icons {
    display: none;
    ${mobile_xl(css`
      display: flex;
    `)}
  }

  ${({ backgroundUrl }) =>
    backgroundUrl &&
    css`
      background-image: url(${backgroundUrl});
      background-size: cover;
      background-position: right;
      ${mobile_xl(css`
        background-image: none;
      `)}
    `}

  &:hover {
    box-shadow: var(--shadow-card);
    border-radius: var(--border-radius-12);
    .inbox-icons {
      display: flex;
    }
  }
  ${mobile_xl(css`
    &:hover {
      box-shadow: unset;
    }
  `)}
  .pointer {
    visibility: visible;
    position: relative;
  }
  ${(props: Props) =>
    props.isIconActive &&
    css`
      .inbox-icons {
        display: flex;
      }
    `}
  ${(props: Props) =>
    props.isRead &&
    css`
      background-color: var(--background-primary);
      .pointer {
        visibility: hidden;
      }
    `}
    ${mobile_xl(css`
    flex-direction: column;
    gap: var(--space-4);
    padding: var(--space-8) var(--space-12) var(--space-8) var(--space-0);
    background-color: transparent;
    border: none;
  `)}
`;

const AvatarDot = styled.div`
  position: relative;
  display: flex;
  gap: var(--space-4);
  ${mobile_xl(css`
    gap: var(--space-6);
    .avatar {
      width: 40px;
      height: 40px;
    }
    .svg-icon {
      width: 40px;
      height: 40px;
    }
    .github-icon {
      width: 40px;
      height: 40px;
    }
  `)}
`;

const MSGdetail = styled.div`
  display: flex;
  gap: var(--space-13);
  width: 100%;
  overflow: hidden;
  ${mobile_xl(css`
    gap: var(--space-16);
  `)}
`;

const DotIcon = styled.div`
  ${mobile_xl(css`
    svg {
      width: 6px;
      height: 6px;
      margin-top: var(--space-18);
    }
  `)}
`;

const IconView = styled.div`
  position: absolute;
  left: 27px;
  top: 18px;
  z-index: var(--z-index-base);
  .project-invited-icon {
    position: absolute;
    left: var(--space-36);
    margin-top: var(--space-18);
  }
  ${mobile_xl(css`
    left: 38px;
    top: 22px;
    .dot-icon {
      width: 6px;
      height: 6px;
      margin-top: var(--space-18);
    }
    .project-invited-icon {
      left: var(--space-40);
      margin-top: var(--space-24);
    }
  `)}
`;
const BlankDiv = styled.div`
  width: 5px;
  height: 5px;
  ${mobile_xl(css`
    width: 6px;
    height: 6px;
  `)}
`;

const MSGtime = styled.div`
  position: relative;
  ${mobile_xl(css`
    display: none;
  `)}
`;

const Desc = styled.div<Props>`
  padding: var(--space-5) var(--space-11);
  background-color: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-8);
  word-break: break-word;
  margin: var(--space-0);
  ${Typography.body_md_medium};
  color: var(--text-primary);
  overflow: hidden;
  ${(props: Props) =>
    props.isImage &&
    css`
      padding: var(--space-12);
    `}
  img {
    display: block;
    width: 88px;
    height: 72px;
    border-radius: var(--border-radius-4);
    padding: var(--space-0);
  }

  .screen-recording-custom-main-div {
    display: none;
  }
  p {
    margin: var(--space-0);
    ${Typography.body_md_medium};
    color: var(--text-primary);
  }
  .task-link-preview-main-div,
  .figma-main-div,
  .project-link-embed-preview-main-div {
    :last-child {
      margin-bottom: var(--space-0);
    }
    margin-bottom: var(--space-0);
  }
  /* inbox table design */
  .tableWrapper {
    width: 100%;
    box-shadow: var(--border-outset);
    border-radius: 6px;
    max-height: 200px;
    margin: var(--space-6) var(--space-0);
    ${HideScrollbar}
    ${mobile_xl(css`
      overflow: hidden;
    `)}
  }
  table {
    width: 100%;
    background: transparent;
    border-collapse: separate;
    border-spacing: 0;
    color: var(--text-primary);
    ${Typography.body_md};
    border-radius: var(--border-radius-6);
    max-height: 192px;
    ${HideScrollbar}
    ${mobile_xl(css`
      overflow: hidden;
    `)}
    tr {
      &:last-child {
        border-bottom: none;
      }
    }
    th,
    td {
      border-bottom: 0.5px solid var(--border-primary);
      border-right: 0.5px solid var(--border-primary);
      padding: var(--space-7) var(--space-10);
      text-align: left;
      background: transparent;
      white-space: nowrap;
      &:last-child {
        border-right: none;
      }
    }
    th:last-child,
    td:last-child {
      border-right: none;
    }
    tr:last-child th,
    tr:last-child td {
      border-bottom: none;
    }
    border-style: hidden;

    th {
      ${Typography.body_md_medium}
      background: var(--neutral-secondary);
    }

    p {
      margin: var(--space-0);
    }
  }
  span {
    margin: var(--space-0);
    ${Typography.body_md_medium};
    color: var(--text-primary);
  }
  .figma-main-div {
    display: flex;
    flex-direction: row-reverse;
    border: none;
    background-color: transparent;
    margin-top: var(--space-6);
    gap: var(--space-12);
    border-radius: var(--border-radius-0);
    .inbox-image {
      border-radius: var(--border-radius-4);
      background: var(--border-primary);
    }
  }
  .figma-header {
    flex-direction: column;
    border: none;
    align-items: flex-start;
    padding: var(--space-0);
    ${mobile_xl(css`
      gap: var(--space-0);
    `)}
  }
  .figma-right-div {
    ${mobile_xl(css`
      margin-top: -1px;
    `)}
  }
  .figma-icon {
    display: none;
  }
  .figma-description {
    color: var(--text-primary);
    ${Typography.body_md_medium};
    text-transform: capitalize;
    ${LineClamp(1)}
  }
  .figma-animation {
    display: none;
  }
  .figma-text {
    flex-direction: column;
    gap: var(--space-4);
    align-items: flex-start;
  }

  a {
    color: var(--text-link);
    text-decoration: underline;
    &:hover {
      text-decoration: none;
    }
  }
  ul,
  ol {
    color: var(--text-primary);
    background-color: transparent;

    :last-child {
      margin-bottom: var(--space-0);
    }
    li {
      ::marker {
        color: var(--text-primary);
        background-color: transparent;
      }
    }
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: var(--space-0);
    ${Typography.body_md_medium};
    color: var(--text-primary);
  }
  pre {
    white-space: normal;
    margin: var(--space-0);
  }
  .e-rte-table td,
  .e-rte-table th {
    border: 0.5px solid var(--border-primary);
  }
  hr {
    border: none;
    margin: var(--space-16) var(--space-0);
    width: 100%;
    height: 0.5px;
    background: var(--border-primary);
  }
`;

const Read = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  ${mobile_xl(css`
    gap: var(--space-4);
  `)}
`;

const MSGtitle = styled.div`
  ${Typography.body_md_medium};
  color: var(--text-primary);
  margin: var(--space-0);
  p {
    margin: var(--space-0);
    span {
      background-color: unset;
    }
  }
  a {
    color: var(--text-link);
    text-decoration: underline;
    &:hover {
      text-decoration: none;
    }
  }

  .dot-icon {
    display: none;
  }
  ${mobile_xl(css`
    ${Typography.body_lg};
    color: var(--text-secondary);
    .dot-icon {
      display: inline;
      ${Typography.body_lg_medium};
    }
    &.overdue-card {
      ${Typography.body_lg_medium};
      color: var(--text-primary);
    }
    &.notification-card {
      ${Typography.body_lg_medium};
      color: var(--text-primary);
    }
    &.desktopNotification-card {
      ${Typography.body_lg_medium};
      color: var(--text-primary);
    }
  `)}
`;

const MSGtext = styled.p`
  ${Typography.body_md};
  color: var(--text-secondary);
  margin: var(--space-0);
  a {
    color: var(--text-link);
  }
  ${mobile_xl(css`
    ${Typography.body_lg_medium};
    color: var(--text-primary);
    &.overdue-card {
      ${Typography.body_lg};
      color: var(--text-secondary);
    }
    &.notification-card {
      ${Typography.body_lg};
      color: var(--text-secondary);
    }
    &.desktopNotification-card {
      ${Typography.body_lg};
      color: var(--text-secondary);
    }
  `)}
`;

const MSGsubtext = styled.p`
  ${Typography.body_md};
  color: var(--text-secondary);
  margin: var(--space-0);
  white-space: nowrap;
  ${mobile_xl(css`
    display: none;
  `)}
`;

const MSGblock = styled.div`
  width: 100%;
  max-width: 490px;
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
  justify-content: center;
  overflow: hidden;
  ${mobile_xl(css`
    max-width: calc(100vw - 95px);
    gap: var(--space-6);
  `)}
`;
const Icons = styled.div<Props>`
  display: flex;
  gap: var(--space-6);
  width: 100%;
  padding: var(--space-2) var(--space-3);
  border-radius: var(--border-radius-full);
  border: 0.5px solid var(--border-primary);
  background-color: var(--background-primary);
  box-shadow: var(--shadow-card);
  .icons {
    cursor: pointer;
    &:hover {
      svg {
        path {
          stroke: var(--brand-primary);
        }
      }
    }
  }
  .icon {
    cursor: pointer;
    path {
      fill: var(--text-secondary);
    }
    &:hover {
      path {
        fill: var(--brand-primary);
      }
    }
  }

  ${(props: Props) =>
    props.isTaskDetailPreview &&
    css`
      padding: var(--space-6);
      flex-direction: column;
      gap: var(--space-4);
      width: max-content;
      border-radius: var(--border-radius-12);
      border: 0.5px solid var(--border-primary);
    `}
  ${mobile_xl(css`
    padding-inline: var(--space-10);
    gap: var(--space-8);
    background-color: unset;
    border-radius: var(--border-radius-0);
    box-shadow: unset;
    width: max-content;
    border: unset;
    ${(props: Props) =>
      props.isTaskDetailPreview &&
      css`
        flex-direction: row;
        padding: var(--space-8);
        gap: var(--space-12);
        box-shadow: var(--shadow-card-hover);
      `};
  `)}
`;

const SvgDiv = styled.div`
  ${FlexCenter}
  position: relative;
  &:hover {
    svg path {
      fill: var(--text-primary);
    }
  }
`;

const Bottom = styled.div`
  position: absolute;
  top: 22px;
  right: 0;
  display: flex;
  justify-content: end;
  ${mobile_xl(css`
    display: none;
  `)}
`;
const BottomButton = styled.div`
  ${AlignCenter}
  padding-top: var(--space-8);
  gap: var(--space-8);
  p {
    color: var(--text-primary);
    ${Typography.body_sm_medium};
    margin: var(--space-0);
    white-space: nowrap;
  }
  ${mobile_xl(css`
    padding-top: var(--space-4);
  `)}
  ${mobile_xs(css`
    gap: var(--space-12);
    flex-wrap: wrap;
    &.overdue {
      align-items: center;
      gap: var(--space-20);
    }
  `)}
`;
const LeftSide = styled.div`
  ${AlignCenter}
`;

const Div = styled.div`
  ${FlexBetween}
  gap: var(--space-24);
  max-width: 602px;
  width: 100%;
  ${mobile_xl(css`
    display: none;
  `)}
`;
const Heading = styled.div`
  ${AlignCenter}
  gap: var(--space-8);
  padding-block: var(--space-3);
`;

const IconDiv = styled.div`
  ${AlignCenter}
`;
const Title = styled.h1`
  ${Typography.heading_md};
  color: var(--text-primary);
  margin: var(--space-0);
  white-space: nowrap;
`;

const Menu = styled.div`
  ${AlignCenter}
  gap: var(--space-4);
`;
const Empty = styled.div`
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  left: 50%;
  ${mobile_xl(css`
    width: max-content;
  `)}
`;

const Header = styled.div`
  ${AlignCenter}
  padding: var(--space-4) var(--space-16);
  border-bottom: 0.5px solid var(--border-primary);
  p {
    color: var(--text-primary);
    ${Typography.body_md_medium};
    margin: var(--space-0) var(--space-18) var(--space-0) var(--space-0);
    width: 100%;
    text-align: center;
  }
  ${mobile_xl(css`
    display: none;
  `)}
`;
const CalendarDropdown = styled.div<Props>`
  display: flex;
  flex-direction: column;
`;

const BottomDiv = styled.div`
  padding: var(--space-12);
  border-top: 0.5px solid var(--border-primary);
  display: flex;
  flex-direction: column;
  gap: var(--space-16);
`;
const ButtonsDiv = styled.div`
  display: flex;
  gap: var(--space-10);
  width: 100%;
  .button {
    width: 100%;
  }
`;
const InputDiv = styled.div`
  display: flex;
  gap: var(--space-10);
  flex-direction: column;
`;
const Inputs = styled.div`
  display: flex;
  gap: var(--space-8);
  flex-direction: column;
`;
const InputLabel = styled.div`
  color: var(--text-secondary);
  ${Typography.body_md_medium};
`;

const Input = styled.div`
  background: var(--background-primary);
  &:focus-visible {
    outline: none;
  }
`;

const Content = styled.div`
  border-radius: var(--border-radius-12);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: var(--z-index-999);
  max-width: 1122px;
  width: 100%;
  height: calc(100dvh - 72px);
  ${mobile_xl(css`
    height: 100dvh;
  `)}
`;
const Overlay = styled.div`
  position: fixed;
  top: var(--space-0);
  left: var(--space-0);
  width: 100%;
  height: 100%;
  background: var(--overlay-preview);
  align-items: center;
  justify-content: center;
  z-index: var(--z-index-999);
`;

const InboxPreviewAction = styled.div`
  border: 0.5px solid var(--border-primary);
  background-color: var(--background-primary);
  border-radius: var(--border-radius-12);
  padding: var(--space-6);
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  ${mobile_xl(css`
    flex-direction: row;
    padding: var(--space-8);
    gap: var(--space-12);
    box-shadow: var(--shadow-card-hover);
  `)}
`;

const ActionSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-12);
  ${mobile_xl(css`
    width: 100%;
    flex-direction: row;
    justify-content: center;
    position: absolute;
    z-index: var(--z-index-99);
  `)}
`;
const DetailPreview = styled.div`
  background-color: var(--background-primary);
  box-shadow: var(--shadow-card);
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-12);
  width: 100%;
  overflow: hidden;
`;
const PreviewSection = styled.div`
  display: flex;
  gap: var(--space-16);
  height: 100%;
`;
const NotificationCard = styled.div<Props>`
  display: flex;
  justify-content: space-between;
  gap: var(--space-8);
  padding: var(--space-12) var(--space-12) var(--space-12) var(--space-16);
  background-color: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-12);
  align-items: baseline;
  cursor: pointer;
  box-shadow: var(--shadow-card);
  background-image: ${({ backgroundUrl }) => (backgroundUrl ? `url(${backgroundUrl})` : '')};
  background-position: right;
  background-size: cover;

  .pointer {
    visibility: visible;
    position: relative;
    margin-left: -5px;
    ${mobile_xl(css`
      margin-left: var(--space-0);
    `)}
  }
  ${mobile_xl(css`
    background-image: none;
    flex-direction: column;
    gap: var(--space-4);
    padding: var(--space-8) var(--space-8) var(--space-8) var(--space-14);
    border: none;
  `)}
`;
const DesktopIcon = styled.div`
  width: 28px;
  height: 28px;
  ${FlexCenter}
  border-radius: var(--border-radius-full);
  background-color: var(--accent-caution);
  .desktop-icon {
    path {
      fill: var(--text-white);
    }
  }
  ${mobile_xl(css`
    width: 42px;
    height: 42px;
    .desktop-icon {
      width: 26px;
      height: 26px;
    }
  `)}
`;
const Description = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  max-width: 426px;
  width: 100%;
`;
const DesktopImage = styled.div`
  max-width: 156px;
  width: 100%;
  border: 0.5px solid var(--background-muted);
  border-radius: var(--border-radius-6);
  display: flex;
`;
const RightContent = styled.div`
  display: flex;
  gap: var(--space-8);
  align-items: flex-start;
  ${mobile_xl(css`
    flex-direction: column;
    gap: var(--space-10);
  `)}
`;

const DateSection = styled.p`
  display: none;
  ${mobile_xl(css`
    display: inline;
    ${Typography.body_lg};
    color: var(--text-secondary);
    margin: var(--space-0);
  `)}
`;
const MainItemDiv = styled.div`
  max-width: 218px;
  width: 100%;
  ${mobile_xl(css`
    max-width: 391px;
  `)}
`;

const ResponsiveSnoozeButton = styled.div`
  display: none;
  ${mobile_xl(css`
    ${AlignCenter}
    gap: var(--space-12);
    padding: var(--space-12);
    margin-inline: var(--space-10);
    width: calc(100% - 44px);
    &:hover {
      background-color: var(--neutral-secondary);
      border-radius: var(--border-radius-8);
    }
    .snooze-text {
      color: var(--text-primary);
    }
    .snooze-icon {
      path {
        fill: var(--text-primary);
      }
    }
  `)}
`;

// swipe container css / styles
export const SwipeRowContainer = styled.div<Props>`
  position: relative;
  overflow: visible;
  animation: none;
  transition: none;
  ${({ isActive }) =>
    isActive &&
    css`
      transform: translateX(0);
      opacity: 1;
    `}
  ${mobile_xl(css`
    overflow: hidden;
  `)}
  &.swipe-row-no-animation {
    overscroll-behavior: auto; /* Prevent scroll chaining to parent scroll containers */
    -webkit-overflow-scrolling: touch; /* Ensures smooth scrolling on iOS */
    -webkit-tap-highlight-color: transparent; /* Removes tap highlight color */
  }
`;

export const SwipeAction = styled.div`
  display: none;
  ${mobile_xl(css`
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    z-index: var(--z-index-base); // behind the sliding content: ;
    ${AlignCenter}
    justify-content: flex-end;
    background-color: var(--border-primary);
    border-top-right-radius: var(--border-radius-12);
    border-bottom-right-radius: var(--border-radius-12);
    border: 0.5px solid var(--background-secondary);
  `)}
`;

export const SwipeMsgCard = styled.div<SwipeMsgCardProps>`
  position: relative;
  border-top-right-radius: var(--border-radius-12);
  border-bottom-right-radius: var(--border-radius-12);
  background-color: var(--background-secondary);
  z-index: var(--z-index-base);
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
  touch-action: pan-y; /* Prevents horizontal scroll but allows vertical scroll */
  overscroll-behavior: contain;
  will-change: transform, opacity;

  /* Transform logic */
  transform: ${({ isDeleting, isSwiped, touchStartX, touchEndX, itemId, swipedItemId, mobile }) => {
    if (mobile && isDeleting) return 'translateX(-100vw)';
    if (isSwiped && swipedItemId === itemId && touchStartX && touchEndX) {
      return `translateX(${Math.max(-146, Math.min(0, touchEndX - touchStartX))}px)`;
    }
    return 'translateX(0)';
  }};

  /* Opacity logic */
  opacity: ${({ isDeleting, mobile }) => (mobile && isDeleting ? 0 : 1)};

  /* Transition logic */
  transition: ${({ isRearranging, isDeleting, swipedItemId, itemId, mobile }) => {
    if (isRearranging) return 'none';
    if (mobile && isDeleting) {
      return 'transform var(--transition-fast) cubic-bezier(0.22, 0.61, 0.36, 1), opacity var(--transition-normal) cubic-bezier(0.22, 0.61, 0.36, 1)';
    }
    if (swipedItemId === itemId) return 'none';
    return 'transform var(--transition-fast) cubic-bezier(0.22, 0.61, 0.36, 1)';
  }};

  /* Animation logic */
  animation: ${({ isRearranging }) => (isRearranging ? 'none' : 'unset')};
`;

const ItemDiv = styled.div`
  min-width: 168px;
  width: 100%;
`;

const NotificationIcon = styled.div`
  padding: var(--space-2);
  background-color: var(--neutral-secondary);
  border: 1px solid var(--background-primary);
  border-radius: var(--border-radius-full);
  ${FlexCenter}
  ${mobile_xl(css`
    border: 2px solid var(--background-secondary);
    background-color: var(--background-muted);
    svg {
      width: 12px;
      height: 12px;
    }
  `)}
`;

const DropDiv = styled.div`
  .active-state {
    border-radius: var(--border-radius-6);
    background-color: var(--background-active-navbar);
    &:hover {
      button {
        background-color: var(--background-active-navbar);
      }
    }
  }
`;

const TooltipTitle = styled.div`
  ${Typography.body_sm}
`;
const TooltipContainer = styled.div`
  ${FlexCenter}
`;

export {
  HeaderInbox,
  InboxMSG,
  MSG,
  MSGdetail,
  MSGtime,
  Desc,
  Read,
  MSGtitle,
  MSGtext,
  MSGsubtext,
  MSGblock,
  MainHeader,
  IconView,
  AvatarDot,
  Icons,
  Bottom,
  BottomButton,
  BlankDiv,
  LeftSide,
  Div,
  Heading,
  Title,
  Menu,
  SvgDiv,
  Empty,
  Header,
  CalendarDropdown,
  BottomDiv,
  ButtonsDiv,
  InputDiv,
  Inputs,
  InputLabel,
  Input,
  Content,
  Overlay,
  InboxPreviewAction,
  ActionSection,
  DetailPreview,
  PreviewSection,
  NotificationCard,
  DesktopIcon,
  Description,
  DesktopImage,
  RightContent,
  DateSection,
  MainItemDiv,
  ResponsiveSnoozeButton,
  ItemDiv,
  NotificationIcon,
  DropDiv,
  IconDiv,
  TooltipTitle,
  TooltipContainer,
  DotIcon,
  InboxContainer,
  DropdownWrapper
};
